import { Link } from "react-router-dom";
import { allDramas } from "@/lib/drama";

const CATEGORY_ENTRIES = [
  {
    label: "现代都市",
    genre: "都市",
    icon: "ri-building-2-line",
    desc: "霓虹与人间烟火",
  },
  {
    label: "职场商战",
    genre: "职场",
    icon: "ri-briefcase-4-line",
    desc: "会议室里的博弈",
  },
  {
    label: "情感疗愈",
    genre: "情感",
    icon: "ri-heart-3-line",
    desc: "温柔而坚定的关系",
  },
  {
    label: "悬疑推理",
    genre: "悬疑",
    icon: "ri-search-eye-line",
    desc: "一层层剥开真相",
  },
  {
    label: "家庭群像",
    genre: "家庭",
    icon: "ri-home-heart-line",
    desc: "餐桌旁的故事",
  },
  {
    label: "年代怀旧",
    genre: "年代",
    icon: "ri-time-line",
    desc: "旧时光的余温",
  },
];

export default function CategoryShortcuts() {
  return (
    <section aria-labelledby="category-shortcuts-title">
      <div className="mb-4 flex items-end justify-between gap-3">
        <div>
          <h2 id="category-shortcuts-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            按题材找剧
          </h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">六大主流题材，一键进入对应剧单</p>
        </div>
        <Link
          to="/category"
          className="shrink-0 whitespace-nowrap text-xs text-primary-600 transition-colors hover:text-primary-800 md:text-sm"
        >
          全部分类
          <i className="ri-arrow-right-s-line ml-0.5" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {CATEGORY_ENTRIES.map((entry) => {
          const count = allDramas.filter((item) => item.genres.includes(entry.genre)).length;
          return (
            <Link
              key={entry.genre}
              to={`/category?genre=${encodeURIComponent(entry.genre)}`}
              className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
                <i className={`${entry.icon} text-lg`} aria-hidden="true" />
              </span>
              <p className="mt-3 text-sm font-medium text-foreground-900">{entry.label}</p>
              <p className="mt-0.5 text-[11px] text-foreground-500">{entry.desc}</p>
              <p className="mt-2 text-[11px] text-primary-600">
                {count} 部剧集
                <i className="ri-arrow-right-up-line ml-1" aria-hidden="true" />
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}